/**
 *
 * 员工选择器
 *
 *
 */
'use strict'

import Vue from 'vue';
import Component from "vue-class-component";

@Component
class POByMarkerSelect extends Vue {
    keyword = '';
    pageIndex = 1;
    pageSize = 10;
    total = ''
    POByMarkerList = [];
    async queryPoAsync(page) {
        if(page && page.type == 'web'){
            this.keyword = page.keyword || '';
            this.pageIndex = page.pageIndex || 1;
            this.pageSize = page.pageSize || 5;
        }

        let params = {
            marker: this.keyword,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }
        this.allLoaded = false
        let result = await this.api.post(this.url.mice.PagingPOByMarker, params);
        if (!result) {

        }
        this.loading = false;
        if(page && page.type == 'web'){
            this.POByMarkerList = result.content.rows;
        }else{
            if(this.pageIndex == 1){
                this.POByMarkerList = [];
            }
            this.POByMarkerList = this.POByMarkerList.concat(result.content.rows);
        }


        if (this.POByMarkerList.length == result.content.total) {
            this.allLoaded = true;
        }
        this.total = result.content.total
        this.POByMarkerList.map((ele) => {
            ele.active = false;
        })
        if(page && page.type == 'web'){
            return;
        }
        this.selected();
    }
}

export default POByMarkerSelect;



// WEBPACK FOOTER //
// ../scripts/components/POByMarkerSelect.js